export { default as GenresPage } from "./genrespage";
